export default {
  combine_voice_service_type: () =>
    import('./widgets/combine_voice_service_type'),
  combine_voice_top_faq: () => import('./widgets/combine_voice_top_faq'),
  combine_voice_top_self_service: () =>
    import('./widgets/combine_voice_top_self_service'),
  combine_voice_top_transfer: () =>
    import('./widgets/combine_voice_top_transfer'),
  combine_voice_volume: () => import('./widgets/combine_voice_volume'),

  heatmap_voice: () => import('./widgets/heatmap_voice'),

  pie_voice_result: () => import('./widgets/pie_voice_result'),
  pie_voice_intent: () => import('./widgets/pie_voice_intent'),

  tag_cloud: () => import('./widgets/tag_cloud'),
  tag_cloud_table: () => import('./widgets/tag_cloud_table'),

  time_serie_active: () => import('./widgets/time_serie_active'),

  widget_voice_offload: () => import('./widgets/widget_voice_offload'),
  widget_voice_service_success: () =>
    import('./widgets/widget_voice_service_success'),
  widget_voice_session: () => import('./widgets/widget_voice_session'),

  // old
  heatmap_chat: () => import('./heatmap_chat'),

  pie_chat_by_channel: () => import('./pie_chat_by_channel'),
  pie_voice_by_channel: () => import('./pie_voice_by_channel'),

  stacked_chat_session_offload: () => import('./stacked_chat_session_offload'),
  stacked_voice_session_offload: () =>
    import('./stacked_voice_session_offload'),
  stacked_voice_session_success: () =>
    import('./stacked_voice_session_success'),

  widget_chat_customer: () => import('./widget_chat_customer'),
  widget_chat_session: () => import('./widget_chat_session'),
  widget_chat_session_success: () => import('./widget_chat_session_success'),
  widget_chat_transfer: () => import('./widget_chat_transfer'),
  widget_voice_answered_call: () => import('./widget_voice_answered_call'),
  widget_voice_call: () => import('./widget_voice_call'),
  widget_voice_campaign: () => import('./widget_voice_campaign'),
  widget_voice_customer: () => import('./widget_voice_customer'),
  widget_voice_session_success: () => import('./widget_voice_session_success'),
  widget_voice_transfer: () => import('./widget_voice_transfer')
}
